import { SelectedShipping } from 'common/types/entities/ShippingFeesInterface'
import { ShippingService } from 'common/types/shippingType'

export const doesShippingServicesHaveShippingMethod = (
  shippingServices: ShippingService[],
  selectedShipping: SelectedShipping | null,
) =>
  selectedShipping &&
  shippingServices.some(({ rules }) =>
    rules.some(
      ({ id, shippingConditions }) =>
        id === selectedShipping.ruleId &&
        (!shippingConditions.length ||
          shippingConditions.some(
            ({ id: conditionIdInRule }) =>
              conditionIdInRule === selectedShipping.conditionId,
          )),
    ),
  )

/**
 * Finds a shipping service that contains a rule with the given ruleId.
 * Used to preserve user's shipping selection when conditions change (e.g., due to quantity changes).
 */
export const findShippingServiceByRuleId = (
  shippingServices: ShippingService[],
  ruleId: number,
): ShippingService | undefined =>
  shippingServices.find(service =>
    service.rules.some(rule => rule.id === ruleId),
  )
